import WordData from '@/user/pages/authorized/study/japanese/work/JapaneseWordData';
import { HEAD_NG_CHAR, TAIL_NG_CHAR } from '@/user/pages/authorized/study/japanese/work/JapaneseWork';


/**
 * 行データクラス
 */
export default class JapaneseLineData {

  /** WordDataリスト */
  public wordList: WordData[] = [];

  /** 行幅 */
  public w = 0;

  /** 行高 */
  public h = 0;

  /** 改行フラグ */
  public lfFlag = false;

  /** フォントサイズ */
  private fontSize = 0;

  /** 余白サイズ */
  private margin = 0;




  /**
   * constructor
   *
   * @param fontSize
   * @param margin
   */
  constructor(
    fontSize: number,
    margin: number
  ) {
    this.w = fontSize;
    this.fontSize = fontSize;
    this.margin = margin;
  }




  /**
   * 単語追加
   */
  public add(wordData: WordData, height: number): boolean {

    // 画面からはみ出す場合（禁則文字が連続した想定）
    if (this.h + wordData.h > height - this.margin) { // 上の余白分のみ確保
      return false;
    }
    // 縦に入りきらない場合
    else if (this.h + wordData.h > height - this.margin * 2) { // 上下の余白を確保
      // 空文字の場合は改行する
      if (wordData.word.length === 0) return false;
      // 行頭禁止文字でない場合は改行する
      if (HEAD_NG_CHAR.indexOf(wordData.word) === -1) return false;
    }
    // 縦の最後の文字の場合
    else if (this.h + wordData.h + this.fontSize > height - this.margin * 2) {
      // 行末禁止文字の場合は改行する
      if (TAIL_NG_CHAR.indexOf(wordData.word) !== -1) return false;
    }
    this.wordList.push(wordData);
    this.w = Math.max(this.w, wordData.w);
    this.h += wordData.h;
    return true;
  }

  /**
   * 改行フラグ追加
   */
  public addLF(): void {
    this.lfFlag = true;
  }

  /**
   * 行末が禁則文字の場合、次行に表示すべき文字を現在行の行末から削り、配列で返却します。
   */
  public checkLastWord(nextLineHeadWordData: WordData): WordData[] {
    // 行に文字がない場合は空を返却
    const count = this.wordList.length;
    if (count === 0) return [];

    // 次行に表示すべき文字の配列
    const nextLineWordDataList = [];

    // 次行の行頭文字が行頭禁則文字の場合（＝連続した行頭禁則文字内での改行）
    if (HEAD_NG_CHAR.indexOf(nextLineHeadWordData.word) > -1) {
      // 行末の連続した行頭禁則文字とその直前の文字を格納
      for (let i = count; 0 < i; i--) {
        const wordData = this.wordList[i - 1];
        nextLineWordDataList.unshift(wordData);
        if (HEAD_NG_CHAR.indexOf(wordData.word) === -1) break;
      }
    }

    // 行全てが行頭禁則文字の場合
    if (count === nextLineWordDataList.length) return [];

    // 行末の行末禁則文字の取得
    const wordData = this.wordList[count - 1 - nextLineWordDataList.length];
    if (TAIL_NG_CHAR.indexOf(wordData.word) > -1) {
      nextLineWordDataList.unshift(wordData);
    }

    // 次行に表示すべき文字がない場合
    if (nextLineWordDataList.length === 0) return [];

    // 現在行の内容調整
    nextLineWordDataList.forEach((wd) => {
      this.wordList.pop();
      this.h -= wordData.h;
    });

    return nextLineWordDataList;
  }




}
